/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_OrderInputs */

const en_tables_pause_reasons_order = /** @type {(inputs: Tables_Pause_Reasons_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Order`)
};

const de_tables_pause_reasons_order = /** @type {(inputs: Tables_Pause_Reasons_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Reasons Order" |
*
* @param {Tables_Pause_Reasons_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_order = /** @type {((inputs?: Tables_Pause_Reasons_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_order(inputs)
	return de_tables_pause_reasons_order(inputs)
});